import { Box } from "@chakra-ui/react";
import { Navbar } from "../components/landing/Navbar";
import { Footer } from "../components/landing/Footer";
import { PageHero } from "../components/common/PageHero";
import { SectionWrapper } from "../components/common/SectionWrapper";
import { ContactIntro } from "../components/contact/ContactIntro";
import { ContactInfo } from "../components/contact/ContactInfo";
import { ContactMap } from "../components/contact/ContactMap";
import { ContactSocials } from "../components/contact/ContactSocials";
import { CONTACT_INFO } from "../data/contact";
import { FiArrowLeft, FiPhone } from "react-icons/fi";

export const ContactPage = () => {
  const scrollToContact = () => {
    document.getElementById("contact-connect")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const openOfficePhone = () => {
    window.location.href = CONTACT_INFO.officePhoneHref;
  };

  return (
    <Box dir="rtl" overflowX="hidden">
      <Navbar />
      <PageHero
        title="ارتباط با"
        titleHighlight="تأمین سرمایه امید"
        subtitle="برای دریافت راهنمایی درباره صندوق‌ها، خدمات تأمین مالی و سایر درخواست‌ها، از سریع‌ترین مسیر ارتباطی با ما استفاده کنید."
        primaryAction={{
          label: "ثبت درخواست",
          icon: FiArrowLeft,
          onClick: scrollToContact,
        }}
        secondaryAction={{
          label: "تماس مستقیم",
          icon: FiPhone,
          onClick: openOfficePhone,
          variant: "secondary",
        }}
      />
      <SectionWrapper contentMaxW="container.lg">
        <ContactIntro />
      </SectionWrapper>
      <SectionWrapper id="contact-connect" alt contentMaxW="container.xl">
        <ContactInfo />
        <ContactSocials />
      </SectionWrapper>
      <SectionWrapper py={0}>
        <ContactMap />
      </SectionWrapper>
      <Footer />
    </Box>
  );
};
